import { Component, Input } from '@angular/core';

/** Temporary screen for menu entries whose feature has not been built yet. */
@Component({
  selector: 'coach-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrl: './placeholder.component.scss',
})
export class PlaceholderComponent {
  @Input() titleKey = '';
}
